import { render, staticRenderFns } from "./ModuleFormDiy.vue?vue&type=template&id=3627680c&scoped=true"
import script from "./ModuleFormDiy.vue?vue&type=script&lang=js"
export * from "./ModuleFormDiy.vue?vue&type=script&lang=js"
import style0 from "./ModuleFormDiy.vue?vue&type=style&index=0&id=3627680c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627680c",
  null
  
)

export default component.exports